import { __assign, __extends } from "tslib";
/* I134 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Feedback = /** @class */ (function (_super) {
    __extends(Feedback, _super);
    function Feedback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Feedback.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("defs", null,
                    React.createElement("path", { d: "M0 0h20v15.938H5.4L0 21V0zm11.237 3l-.175.172-.832 1.535-.262.17H7v2.345h1.632l.145.17L7 10.68v1.706h1.762l.176-.171.832-1.535.262-.171H13V8.166h-1.632l-.145-.171L13 4.707V3h-1.763z", id: "I134-a" })),
                React.createElement("use", { fill: "currentColor", xlinkHref: "#I134-a", transform: "translate(2 2)", fillRule: "evenodd" }))));
    };
    return Feedback;
}(React.Component));
export { Feedback };
export default Feedback;
//# sourceMappingURL=Feedback.js.map